<template lang="pug">
  #ch4interactive.container-fluid
    .row.d-flex.justify-content-center.align-items-center
      .col-12.desktop.mt-5.d-flex.flex-column.justify-content-center.align-items-center
        p.d-inline-flex.px-4.py-0.mb-0.text-center.subtitle
          span.white ¿Cuántas personas como tú tienen
        p.d-inline.px-4.pb-1.mb-2.text-center.subtitle
          span.obesidad obesidad
          span ,&nbsp;
          span.diabetes diabetes&nbsp;
          span o&nbsp;
          span.hipertension hipertensión?
    .row.my-2.py-4.py-lg-3.d-flex.justify-content-center.align-items-center.diseases
      .col-12.d-flex.flex-column.flex-lg-row.justify-content-center.align-items-center
        button.btn.col-12.col-lg-2.mx-2.my-2(:class="{'obesidad' : disease === 'obesidad'}" @click="disease = 'obesidad'") Obesidad
        button.btn.col-12.col-lg-2.mx-2.my-2(:class="{'diabetes' : disease === 'diabetes'}" @click="disease = 'diabetes'") Diabetes
        button.btn.col-12.col-lg-2.mx-2.my-2(:class="{'hipertension' : disease === 'hipertension'}" @click="disease = 'hipertension'") Hipertensión
    .row.d-flex.justify-content-center.align-items-center
      .col-12.col-lg-8
        .row.d-flex.justify-content-center.align-items-center
          Ch4Grid.col-12.col-lg-6.pr-4
          Ch4Grid.col-12.col-lg-6.pl-4.d-none.d-lg-block.l-border(compare="true")
</template>

<script>
import Ch4Grid from "@/components/chapter4/Ch4Grid.vue";

export default {
  name: "ch4grid",
  components: {
    Ch4Grid
  },
  computed: {
    disease: {
      get() {
        return this.$store.state.disease;
      },
      set(newValue) {
        this.$store.state.disease = newValue;
      }
    }
  }
};
</script>

<style lang="scss">
#ch4interactive {
  background-color: #0a1d59;
  .subtitle {
    font-family: "Inria Sans", sans-serif;
    font-size: 41.2px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.62px;
    color: #ffffff;
    .white {
      color: #0a1d59;
      background-color: #ffffff;
    }
    .obesidad {
      color: #ff6561;
    }
    .diabetes {
      color: #f0bf5f;
    }
    .hipertension {
      color: #34afb2;
    }
  }
  .diseases {
    background-color: #03123f;
    button {
      width: 158px;
      height: 43px;
      border-radius: 8px;
      border: solid 2px #ffffff;
      background-color: #03123f;
      font-family: "Inria Sans", sans-serif;
      font-size: 18px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: -0.37px;
      color: #ffffff;
      &:hover {
        background-color: #ff6561;
      }
      &.active {
        background-color: #ff6561;
      }
      &.obesidad {
        background-color: #ff6561;
      }
      &.diabetes {
        background-color: #f0bf5f;
      }
      &.hipertension {
        background-color: #34afb2;
      }
    }
  }
  .l-border {
    border-left: 1px white solid;
  }
}
</style>
